import { render, staticRenderFns } from "./RequestTabs.vue?vue&type=template&id=4c9e33fc&scoped=true"
import script from "./RequestTabs.vue?vue&type=script&lang=js"
export * from "./RequestTabs.vue?vue&type=script&lang=js"
import style0 from "./RequestTabs.vue?vue&type=style&index=0&id=4c9e33fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9e33fc",
  null
  
)

export default component.exports